import { useEffect } from 'react'
import { useSearchParams } from 'react-router'
import type { FollowMeTabNav } from '@core/Areas/FollowMe/types'

const allowedTabs: FollowMeTabNav[] = ['explore', 'following']

export const useValidatedTabParam = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const currentTab = (searchParams.get('tab') || 'explore').toLowerCase()
  const isValid = allowedTabs.includes(currentTab as FollowMeTabNav)

  useEffect(() => {
    if (!isValid) {
      setSearchParams({ tab: 'explore' }, { replace: true })
    }
  }, [isValid, setSearchParams])
}
